import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import EmptyState from './EmptyState';
import TableHistory from './TableHistory';

function BodyHistory() {
  const { isEmptyHistory } = useMemberExtract();

  return <div className="corporate-club-extract__card__body">{isEmptyHistory ? <EmptyState /> : <TableHistory />}</div>;
}

export default BodyHistory;
